import React from "react";
import { Route, Switch } from "react-router";
import SerialPage from "./SerialPage";
import EditSerialPage from "./EditSerialPage";

export const navLinks = [
    {path: "/series", text: "Series"},
]

export default function GreenApiPage() {
    return (
        <>
            <Switch>
                <Route exact path="/series" component={SerialPage}/>
                <Route exact path="/series/:view/:id" component={EditSerialPage}/>
                <Route exact path="/series/:edit/:id" component={EditSerialPage}/>
            </Switch>
        </>
    )
}